export default {
  professorName: 'Nombre del Docente',
  professorEmail: 'Correo Electrónico',
  studentAttentionSchedule: 'Horario de Atención al Estudiante',
  coexistenceRulesPrefix: 'Normas de Convivencia para la',
};
